import React, { useState, useEffect, Fragment } from "react";
import SmileChatSvg from "../../images/newHome/chat_icon.png"
import ChatSvg from "../../images/newHome/weChat_icon.png"
import LocationSvg from "../../images/newHome/loction_icon.png"
import SectionTitle from "./SectionTitle";

function BusinessSection() {

    const items = [
        {
            title: 'Transportation',
            icon: SmileChatSvg,
            desc: 'Ensure compliance for automotive, aviation, and mobility solutions.',
            actionText: 'Learn More'
        },
        {
            title: 'Partner Solution',
            icon: ChatSvg,
            desc: 'Collaborate with trusted labs and compliance experts',
            actionText: 'Discover Partners'
        },
        {
            title: 'Healthcare',
            icon: LocationSvg,
            desc: 'Medical device and health tech compliance services.',
            actionText: 'Explore Healthcare'
        },
        {
            title: 'Retail',
            icon: SmileChatSvg,
            desc: 'Compliance solutions for e-commerce and physical retail businesses.',
            actionText: 'Learn More'
        },
        {
            title: 'Manufacturing',
            icon: ChatSvg,
            desc: 'Meet industry standards for product safety and quality.',
            actionText: 'Discover Partners'
        },
        {
            title: 'Finance',
            icon: LocationSvg,
            desc: 'Regulatory compliance for fintech and banking solutions.',
            actionText: 'Discover Finance Solutions'
        }
    ];

    return (
        <Fragment>
            <div className="container lg:p-20 p-4 text-center">
                <div className="text-white lg:mt-[unset] mt-1">
                    <SectionTitle
                        size="font-inter lg:text-5xl text-3xl"
                        weight="font-bold"
                        color="text-titleColor"
                        className="mb-[18px]"
                    >
                        Find what Fits Your Business Needs
                    </SectionTitle>
                    <p className="lg:text-lg text-base text-gray-400">Explore industry-specific compliance solutions designed to streamline your testing and certification process.</p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:p-4 mt-6">
                    {items.map((item, index) => (
                        <div key={index} className="bg-lightGrayBgColor p-6">
                            <div className="bg-iconBg rounded-md w-[48px] h-[48px] flex items-center justify-center">
                                <img src={item.icon} alt={item.icon} />
                            </div>
                            <div className="mt-16">
                                <p className="text-start text-black xl:text-xl lg:text-xl text-base font-medium">
                                    {item.title}
                                </p>
                                <p className="text-start text-base text-gray-400 mt-4">
                                    {item.desc}
                                </p>
                                <p className="text-start text-base text-primaryColor mt-5 font-medium">
                                    {item.actionText}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Fragment>
    )
}

export default BusinessSection;